<div
  class="details position-absolute start-5 z-3 top-26 max-vh-70 overflow-auto"
  cdkDrag
  cdkDragBoundary="app-root"
  [class.d-none]="details().size <= 0"
>
  <app-details
    class="container-fluid p-0"
    (closed)="close()"
    (selectedItemChanged)="toggleFeature($event)"
    [numberOfDetails]="features().length"
    [index]="index()"
  >
    <div class="p-2">
      <div class="row">
        <app-details-meta-category class="col" [category]="details().get('Properties')">
        </app-details-meta-category>
        <app-details-signs class="col-3 start-5" [details]="details()"></app-details-signs>
        <details-accordion-basic
          class="col-12 p-1 mt-2"
          [rawFeature]="rawFeature()"
        ></details-accordion-basic>
        <app-details-links
          class="p-1 mt-2"
          [rawFeature]="rawFeature()"
          [zoomLevel]="zoomLevel()"
        ></app-details-links>
        <div class="col-12 p-1 mt-2">
          @if (!appState.isHistoryEnabled()) {
            <button
              type="button"
              class="rb-btn rb-btn-outline-secondary w-100"
              data-cy="sign-report-open-btn"
              (click)="openReportDialog()"
            >
              <span class="rb-ic rb-ic-alert-warning me-1"></span>
              Report Issue
            </button>
          }
        </div>
      </div>
    </div>
    <div
      cdkDragHandle
      class="rb-ic rb-ic-drag-handle text-gray fs-2xl z-3 position-absolute bottom-2 end-2 cursor-pointer hover-effect"
    ></div>
  </app-details>
</div>

@if (showReportDialog()) {
  <app-sign-report-dialog
    [signId]="selectedFeatureId()"
    [longitude]="getReportLocation().lon ?? null"
    [latitude]="getReportLocation().lat ?? null"
    [signType]="properties()?.mainType ?? ''"
    [speedLimit]="properties()?.speedLimit ?? null"
    [displayType]="properties()?.displayType ?? ''"
    [supplementarySigns]="getReportSupplementarySigns()"
    (closed)="closeReportDialog()"
  ></app-sign-report-dialog>
}
